//数据接口地址
// export const API_URL = 'http://8.131.233.130:90';
export const API_URL = 'https://www.asfcyy.com:8080';